module.exports = __webpack_public_path__ + "static/media/logo-header.c290e984.png";